import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import {
  PAGE_MYPROFILE,
  PAGE_MYPROFILE_DOCUMENT,
  PAGE_MYPROFILE_EDUCATION,
  PAGE_MYPROFILE_EMERGENCY,
  PAGE_MYPROFILE_PRESONAL,
  PAGE_MYPROFILE_WORKHISTORY
} from '../../router/routes'
import { Link, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

function NavbarEmpInfo() {
  const locaiton = useLocation()
  const pathname = locaiton.pathname

  const roleId = useSelector((state) => state.roleReducer.role)

  const getLinkQuery = (url) => {
    return `${url}`
  }
  const menu = [
    {
      id: uuidv4(),
      name: 'Job Position',
      link: getLinkQuery(PAGE_MYPROFILE)
    },
    {
      id: uuidv4(),
      name: 'Personal Details',
      link: getLinkQuery(PAGE_MYPROFILE_PRESONAL)
    },
    {
      id: uuidv4(),
      name: 'Emergency Contact',
      link: getLinkQuery(PAGE_MYPROFILE_EMERGENCY)
    },
    {
      id: uuidv4(),
      name: 'Education History',
      link: getLinkQuery(PAGE_MYPROFILE_EDUCATION)
    },
    {
      id: uuidv4(),
      name: 'Work History',
      link: getLinkQuery(PAGE_MYPROFILE_WORKHISTORY)
    },
    {
      id: uuidv4(),
      name: 'Document',
      link: getLinkQuery(PAGE_MYPROFILE_DOCUMENT)
    }
    // {
    //   id: uuidv4(),
    //   name: 'Certificate',
    //   link: getLinkQuery(PAGE_MYPROFILE_CERTIFICATE)
    // }
  ]
  const chkIsSubMenu = (d) => {
    let path = getLinkQuery(pathname)

    return path === d.link
  }

  return (
    <div
      className="d-flex p-3 "
      style={{ backgroundColor: '#EFEFEF', maxHeight: '53px' }}
    >
      {menu.map((m, i) => (
        <Link
          to={m.link}
          key={m.id}
          style={{ whiteSpace: 'nowrap' }}
          className={`me-3 small text-reset text-decoration-none ${
            chkIsSubMenu(m) ? '' : 'opacity-25'
          }`}
        >
          {m.name}
        </Link>
      ))}
    </div>
  )
}

export default NavbarEmpInfo
